import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent extends BaseListCtl {

  gateList= null;
  unitList = null;

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute) {
    super(locator.endpoints.DEPARTMENT,locator,route);
  }

  populateForm(form, data) {
    form.id = data.id;
    form.name = data.name;
    form.unitId=data.unitId;
    form.unitName=data.unitName;
    form.gateId=data.gateId;
    form.gateName=data.gateName;
    form.emailId=data.emailId;
    form.mobile=data.mobile;
    form.description = data.description;
    
    console.log('----->',data);
  }

  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    }
    return null;
}
preloadByUnit(dID) {
  console.log("======preloadByUnit========");
  if (dID != null && dID >= 0) {

    var _self = this;
    _self.gateList = null;
    _self.unitList = null;
    // _self.form.data["employeeId"] == null;
    var searchParam = { "unitId": dID }
    let gateUrl = _self.endpoint + "/preloadByUnit/" + dID;
    console.log(_self.endpoint, " Search Form ", searchParam);
    this.locator.http.get(gateUrl, function (res, error) {

      if (res.success) {
        console.log("===" + res.result.gateList)
        _self.gateList = res.result.gList;
        _self.unitList = res.result.unitList;
        // _self.form.data["unitId"] = res.result.unitId;
        // _self.form.data["gateId"] = res.result.gateId;
        // _self.form.data["unitName"] = res.result.unitName;
        // _self.form.data["gateName"] = res.result.gateName;
        console.log("List Size", _self.gateList);
      }

    });

  }
}
 title = 'FormValidation';  
 mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";  
isValidFormSubmitted = false;  
onFormSubmit(form: NgForm) {  
  this.isValidFormSubmitted = false;  
  if (form.invalid) {  
     return;  
  }  
  this.isValidFormSubmitted = true;  
  form.resetForm();  
} 
emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  

  iseValidFormSubmitted = false;  
    oneFormSubmit(form: NgForm) {  
    this.iseValidFormSubmitted = false;  
    if (form.invalid) {  
       return;  
    }
    this.iseValidFormSubmitted = true;  
    form.resetForm();  
 }
}
